import React, { useState, useCallback } from 'react';
import useVideoStore from './stores/useVideoStore';
import VideoUrlField from './VideoUrlField';
import ShortDescriptionFields from './ShortDescriptionFields';
import ImageUpload from '../shared/ImageUpload';
import ContentTabBar from '../ArticleFormNew/ContentTabBar';
import RichTextEditor from '../ArticleFormNew/RichTextEditor';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function FormBody({ scheduleAutosave, csrfToken }) {
  var t = useTranslations();
  const [activeTab, setActiveTab] = useState('id');
  const contentId = useVideoStore((s) => s.content_id);
  const contentEn = useVideoStore((s) => s.content_en);
  const thumbnail = useVideoStore((s) => s.thumbnail);
  const thumbnailUrl = useVideoStore((s) => s.thumbnail_url);
  const publishErrors = useVideoStore((s) => s.publishErrors);
  const updateField = useVideoStore((s) => s.updateField);

  const handleIdChange = useCallback((html) => {
    updateField('content_id', html);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleEnChange = useCallback((html) => {
    updateField('content_en', html);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleFileSelect = useCallback((file) => {
    updateField('thumbnail', file);
    updateField('remove_thumbnail', false);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleImageRemove = useCallback(() => {
    updateField('thumbnail', null);
    updateField('thumbnail_url', null);
    updateField('remove_thumbnail', true);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  return (
    <div className="form-body">
      <VideoUrlField scheduleAutosave={scheduleAutosave} />
      <ShortDescriptionFields scheduleAutosave={scheduleAutosave} />
      <div data-tour="cover_image">
        <ImageUpload
          file={thumbnail}
          imageUrl={thumbnailUrl}
          errors={publishErrors && publishErrors.thumbnail ? publishErrors.thumbnail : null}
          onFileSelect={handleFileSelect}
          onRemove={handleImageRemove}
          translations={t}
        />
      </div>
      <div data-tour="content_tabs">
        <ContentTabBar activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div data-tour="editor" className={activeTab === 'id' ? 'd-block' : 'd-none'}>
        <RichTextEditor
          content={contentId}
          onChange={handleIdChange}
          placeholder={t.content_id_placeholder}
          csrfToken={csrfToken}
        />
      </div>
      <div className={activeTab === 'en' ? 'd-block' : 'd-none'}>
        <RichTextEditor
          content={contentEn}
          onChange={handleEnChange}
          placeholder={t.content_en_placeholder}
          csrfToken={csrfToken}
        />
      </div>
    </div>
  );
}
